import React from "react";
import "../assets/css/styles.css"; // Your custom styles
import "bootstrap/dist/css/bootstrap.min.css";  // Bootstrap styles
import Formy from "../components/Formy";

const Home = () => {
  return (
    <div>
      <h1>There's puddles everywhere</h1>
      <p>Guess it must have rained last night</p>
      <Formy/>

    </div>
  );
};

export default Home;
